<template>
  <vx-card :title="natural_entity_id === null ? 'Cadastrar Pessoa Natural' : 'Editar Pessoa Natural'">
    <vs-tabs :color="colorx" v-model="tabIndex">
      <vs-tab label="Dados Básicos">
        <NaturalEntity :services="services" :naturalEntityId="natural_entity_id" />
      </vs-tab>
      <vs-tab label="Endereço" :disabled="isTabEnabled">
        <Address :services="services" :addressTypeList="addressTypeList" />
      </vs-tab>
      <vs-tab label="Telefone" :disabled="isTabEnabled">
        <Phone :services="services" />
      </vs-tab>
      <vs-tab label="Email" :disabled="isTabEnabled">
        <Email :services="services" :emailTypeList="emailTypeList" />
      </vs-tab>
      <!-- <vs-tab label="Dados Bancários" :disabled="isTabEnabled">
        <Bank :services="services" />
      </vs-tab> -->
      <!-- <vs-tab label="Dados Profissionais" :disabled="isTabEnabled">
        <Occupation :services="services" />
      </vs-tab> -->
      <!-- <vs-tab label="Documentos" :disabled="isTabEnabled">
        <Document :services="services" personType="PF" />
      </vs-tab> -->
    </vs-tabs>
  </vx-card>
</template>

<script>
import Datepicker from 'educatena-vuejs-datepicker'
import { ptBR } from 'educatena-vuejs-datepicker/dist/locale'
import vSelect from 'vue-select'
import Constants from '../../../../util/Constants'

import FederationUnitService from '@/services/api/FederationUnitService'
import CityService from '@/services/api/CityService'
import PeopleService from '@/services/api/PeopleService'
import NaturalEntityService from '@/services/api/NaturalEntityService'
import LegalEntityService from '@/services/api/LegalEntityService'
import EmailTypeService from '@/services/api/EmailTypeService'
import AddressService from '@/services/api/AddressService'
import AddressTypeService from '@/services/api/AddressTypeService'
import EmailService from '@/services/api/EmailService'
import FinancialInstitutionService from '@/services/api/FinancialInstitutionService'
import BankDetailService from '@/services/api/BankDetailService'
import PhoneTypeService from '@/services/api/PhoneTypeService'
import PhoneService from '@/services/api/PhoneService'
import AreaCodeService from '@/services/api/AreaCodeService'
import DocumentTypeService from '@/services/api/DocumentTypeService'
import DocumentPeopleService from '@/services/api/DocumentPeopleService'
import OccupationService from '@/services/api/OccupationService'
import PronounTreatmentService from '@/services/api/PronounTreatmentService'

import NaturalEntity from '../tabs/NaturalEntity'
import Address from '../tabs/Address'
import Email from '../tabs/Email'
import Bank from '../tabs/Bank'
import Phone from '../tabs/Phone'
import Document from '../tabs/Document'
import Occupation from '../tabs/Occupation'

export default {
  components: {
    Datepicker,
    vSelect,
    NaturalEntity,
    Address,
    Email,
    Bank,
    Phone,
    Document,
    Occupation
  },
  props: {
    natural_entity_id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    tabIndex: 0,
    federationUnitList: [],
    emailTypeList: [],
    addressTypeList: [],
    services: {
      federationUnitService: null,
      cityService: null,
      peopleService: null,
      naturalEntityService: null,
      legalEntityService: null,
      emailTypeService: null,
      addressService: null,
      addressTypeService: null,
      emailService: null,
      financialInstitutionService: null,
      bankDetailService: null,
      phoneTypeService: null,
      phoneService: null,
      areaCodeService: null,
      documentTypeService: null,
      documentPeopleService: null,
      occupationService: null,
      pronounTreatmentService: null,
    },
    naturalEntityReady: false
  }),
  methods: {
    save() {
      if (this.tabIndex === 0) {
        this.saveNaturalEntity()
      }
    },
    naturalEntityUpdated() {
      this.naturalEntityReady = true
    }
  },
  computed: {
    isTabEnabled() {
      return this.natural_entity_id === null
    }
  },
  mounted() {},
  beforeMount() {
    this.$vs.loading()

    this.services.federationUnitService = FederationUnitService.build(this.$vs)
    this.services.cityService = CityService.build(this.$vs)
    this.services.peopleService = PeopleService.build(this.$vs)
    this.services.naturalEntityService = NaturalEntityService.build(this.$vs)
    this.services.legalEntityService = LegalEntityService.build(this.$vs)
    this.services.emailTypeService = EmailTypeService.build(this.$vs)
    this.services.addressService = AddressService.build(this.$vs)
    this.services.addressTypeService = AddressTypeService.build(this.$vs)
    this.services.emailService = EmailService.build(this.$vs)
    this.services.financialInstitutionService = FinancialInstitutionService.build(
      this.$vs
    )
    this.services.bankDetailService = BankDetailService.build(this.$vs)
    this.services.phoneTypeService = PhoneTypeService.build(this.$vs)
    this.services.phoneService = PhoneService.build(this.$vs)
    this.services.areaCodeService = AreaCodeService.build(this.$vs)
    this.services.documentTypeService = DocumentTypeService.build(this.$vs)
    this.services.documentPeopleService = DocumentPeopleService.build(this.$vs)
    this.services.occupationService = OccupationService.build(this.$vs)
    this.services.pronounTreatmentService = PronounTreatmentService.build(this.$vs)

    this.services.emailTypeService.all().then(data => {
      this.emailTypeList = data
    })

    this.services.addressTypeService.all().then(
      data => {
        this.addressTypeList = data
        this.$vs.loading.close()
      },
      error => {
        this.$vs.loading.close()
      }
    )
  }
}
</script>